import { createSelector } from 'reselect'

export const getHouseTypeRoot = createSelector(
  [
    state => state.houseType.rootNode,
  ],
  rootNode => rootNode,
)

export const getHouseType = createSelector(
  [
    state => state.houseType,
  ],
  houseType => houseType,
)

export const getLayouts = createSelector(
  [
    object => object.state.core.nodes,
    object => object.id,
  ],
  (nodes, id) => nodes.find(node => node.id === id).layouts,
)



// WEBPACK FOOTER //
// ./src/modules/houseType/selectors.js